import {
    Box,
    Container,
    Grid,
    MenuItem,
    Modal,
    Table,
    TableBody,
    TableCell,
    TableRow,
    TextField,
    Typography
} from "@mui/material";
import {StyledButtonContainer, StyledButtonOrange, StyledTableCell} from "../../styles/MyStyles";
import React, {useEffect, useState} from "react";
import {GetEnumMenuItems, GetEnumValueName} from "../../logic/EnumHelper";
import * as ClientDetailsHelper from "../../logic/ClientDetailsHelper";
import * as DataProvider from "../../logic/DataProvider";
import {CreateDataUpdateTicket} from "../../logic/TicketHelper";
import {useNavigate} from "react-router-dom";


const ProfilePage = () => {
    const navigate = useNavigate();
    const [editMode, setEditMode] = useState(false);
    const [errors, setErrors] = useState({});
    const [clientDetails, setClientDetails] = useState({});
    const [showRedirectModal, setShowRedirectModal] = useState(false);

    useEffect(() => {
        fetchClientDetails();
    }, []);

    const fetchClientDetails = () => {
            try {
                let currentClient = DataProvider.GetCurrentClient();
                setClientDetails(JSON.parse(JSON.stringify(currentClient)));
            } catch (error) {
                console.log('An error occurred:', error);
        }
    };

    const handleEditModeToggle = () => {
        setEditMode((prevEditMode) => !prevEditMode);
    };

    const handleRequestUpdating = async () => {

        await CreateDataUpdateTicket(0, clientDetails);

        setShowRedirectModal(true);
    };

    const handleCancelEdit = () => {
        fetchClientDetails();
        setEditMode(false);
    };

    const handleCloseRedirectModal = (redirect) => {
        if (redirect) {
            navigate('/tickets');
        } else {
            setEditMode(false);
        }
    };

    const handleClientDetailsChange = (field, value) => {
        if (field.includes('.')) {
            let fieldSplitted = field.split('.');
            let firstLevel = fieldSplitted[0];
            let secondLevel = fieldSplitted[1];
            let firstLevelValues = clientDetails[firstLevel];

            firstLevelValues[secondLevel] = value;

            setClientDetails({
                ...clientDetails,
                [firstLevel]: firstLevelValues,
            });
        } else {
            setClientDetails({
                ...clientDetails,
                [field]: value,
            });
        }
    };

    return (
        <Container sx={{ margin: '0.2rem', minWidth: '99%' }}>
            <StyledButtonContainer container>
                <Grid>
                    <StyledButtonOrange variant="contained" onClick={editMode ? handleCancelEdit : handleEditModeToggle}>
                        {editMode ? 'Back' : 'Update'}
                    </StyledButtonOrange>
                </Grid>
                {editMode && (
                    <Grid>
                        <StyledButtonOrange variant="contained" onClick={handleRequestUpdating}>
                            Request updating
                        </StyledButtonOrange>
                    </Grid>
                )}
            </StyledButtonContainer>
            <Table>
                <TableBody>
                    <TableRow>
                        <StyledTableCell style={{ width: '10%' }}>Type</StyledTableCell>
                        <TableCell style={{ width: '90%' }}>
                            {editMode ? (
                                <TextField
                                    name="type"
                                    label="Type"
                                    select
                                    value={clientDetails.type}
                                    onChange={(e) => handleClientDetailsChange('type', e.target.value)}
                                    fullWidth
                                    required
                                    disabled={true}
                                    error={!!errors.type}
                                    helperText={errors.type}
                                >
                                    {GetEnumMenuItems('clientType')}
                                </TextField>
                            ) : (
                                GetEnumValueName('clientType', clientDetails.type)
                            )}
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <StyledTableCell style={{ width: '10%' }}>Email</StyledTableCell>
                        <TableCell style={{ width: '90%' }}>
                            {editMode ? (
                                <TextField
                                    name="email"
                                    label="Email"
                                    value={clientDetails.email}
                                    onChange={(e) => handleClientDetailsChange('email', e.target.value)}
                                    fullWidth
                                    size='small'
                                    required
                                    error={!!errors.email}
                                    helperText={errors.email}
                                />
                            ) : (
                                clientDetails.email
                            )}
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <StyledTableCell style={{ width: '10%' }}>Dossier Id</StyledTableCell>
                        <TableCell style={{ width: '90%' }}>
                            {editMode ? (
                                <TextField
                                    name="dossierId"
                                    label="Dossier Id"
                                    value={clientDetails.dossierId}
                                    onChange={(e) => handleClientDetailsChange('dossierId', e.target.value)}
                                    fullWidth
                                    size='small'
                                    required
                                    error={!!errors.dossierId}
                                    helperText={errors.dossierId}
                                />
                            ) : (
                                clientDetails.dossierId
                            )}
                        </TableCell>
                    </TableRow>
                    {clientDetails.type === 0 && ClientDetailsHelper.GetPrivateRows(editMode, clientDetails, handleClientDetailsChange, errors)}
                    {clientDetails.type === 1 && ClientDetailsHelper.GetLegalRows(editMode, clientDetails, handleClientDetailsChange, errors)}
                </TableBody>
            </Table>
            {showRedirectModal && (<Modal open={showRedirectModal} onClose={() => handleCloseRedirectModal(true)}>
                <Box sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: 400,
                    bgcolor: 'background.paper',
                    border: '2px solid #000',
                    boxShadow: 24,
                    p: 4,
                }}>
                    <Typography variant="h6" component="h2">
                        This action creates a new Ticket, the status of which you can see in the Tickets section.
                    </Typography>
                    <Grid container spacing={2} marginTop={3}>
                        <Grid item xs={12} md={12}>
                            <StyledButtonOrange onClick={() => handleCloseRedirectModal(true)}>
                                Ok
                            </StyledButtonOrange>
                        </Grid>
                    </Grid>
                </Box>
            </Modal>)}
        </Container>
    );
};
export default ProfilePage;